import emailjs from 'emailjs-com';
import React, { useRef } from 'react';
import { BsWhatsapp } from 'react-icons/bs';
import { HiOutlineMail } from 'react-icons/hi';
import { RiMessengerLine } from 'react-icons/ri';
import './contact.css';

const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_3jzvo53', 'template_or0jbch', form.current, 'cosDc2gQSfcnxpYav');

    e.target.reset();
  };
  return (
    <section id='contact'>
      <h5>Get In Touch</h5>
      <h2>Contact Me</h2>

      <div className="container contact__container">
        <div className="contact__options">
          <article className="contact__option">
          <div className="flex justify-center items-center">
            <HiOutlineMail className="contact__option-icon"/>
            </div>
            <h4>Email</h4>
            <h5>henry.ndk.tran@gmail.com</h5>
            <a href="mailto:henry.ndk.tran@gmail.com" target="_blank" rel="noreferrer">Send a message</a>
          </article>

          <article className="contact__option">
          <div className="flex justify-center items-center">
            <RiMessengerLine className="contact__option-icon"/>
            </div>
            <h4>Messenger</h4>
            <h5>Khương Trần</h5>
            <a href="https://m.me/100011402608091" target="_blank" rel="noreferrer">Send a message</a>
          </article>

          <article className="contact__option">
            <div className="flex justify-center items-center">
            <BsWhatsapp className="contact__option-icon"/>
            </div>
            <h4>WhatsApp</h4>
            <h5>(240) 722-7978</h5>
            <a href="https://api.whatsapp.com/send?phone=2407227978" target="_blank" rel="noreferrer">Send a message</a>
          </article>

        </div>
        {/* END OF CONTACT OPTIONS */}
        <form ref={form} onSubmit={sendEmail}>
          <input type="text" name='name' placeholder='Your Name' required />
          <input type="email" name='email' placeholder='Your Email' required />
          <input type="text" name='subject' placeholder='Subject' optional/>
          <textarea name="message" rows="7" placeholder='Your Message' required></textarea>
          <button type='submit' className='btn btn-primary'>Send Message</button>
        </form>
      </div>
    </section>
  )
}

export default Contact